import { DashboardEnrollmentPresenter } from 'types/enrollmentService';
import { BiGroup, RenewalAgentOfRecord } from 'types/groupService';

export type BiDashboardGroupPresenter = Pick<
  BiGroup,
  | 'id'
  | 'name'
  | 'agentOfRecord'
  | 'assigned'
  | 'source'
  | 'lastUpdateTime'
  | 'agency'
  | 'archived'
  | 'carrierGroupNumber'
  | 'contactInfo'
> & {
  enrollments: DashboardEnrollmentPresenter[];
};

export interface SelectedGroup {
  id: string;
  name: string;
  agencyId: string;
  aor: RenewalAgentOfRecord | null;
}

export enum GroupAction {
  REMOVE = 'REMOVE',
  ARCHIVE = 'ARCHIVE',
  MOVE = 'MOVE',
}

export interface BiGroupInteractionController {
  commitGroupAction(
    groupAction: GroupAction,
    groupId: string,
    groupName: string,
    agencyId: string,
    aor: RenewalAgentOfRecord | null,
  ): void;
  unarchiveGroup: (groupId: string) => Promise<void>;
  viewGroupProfile: (groupId: string, agencyId: string, agencyName: string) => Promise<void>;
}
